"use client";
import Link from "next/link";
import React from "react";

import { textEllipsisOverflow } from "@/utils/common-functions";
import { routes } from "@/utils/routes";
import { ArticleType } from "@/@types/BlogArticle";
import { otherBlogs } from "@/utils/content";

interface FeaturedBlogItemProps {
  article: ArticleType;
}

const FeaturedList = ({ article }: FeaturedBlogItemProps) => {
  const { title, date, category, id } = article;
  const content = otherBlogs.en;

  return (
    <div className="border-bottom mt-3">
      <Link className="text-secondary" href={`${routes.blog}/${id}`}>
        <div>
          <p className="fw-bold">{textEllipsisOverflow(title, 50)}</p>
          <div className="d-flex justify-content-between">
            <div className="date">{date}</div>
            <p className="category">
              {textEllipsisOverflow(
                category ? category : content.noCategory,
                70
              )}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FeaturedList;
